import React from "react";
import { SocialIcon } from "react-social-icons";
import "./Footer.css";
import "../../assets/logo";

function Footer() {
  return (
    <section className="w-full h-auto bg-BleuClair text-white flex justify-center items-center py-[40px]">
      <div className="md:max-w-[1500px] w-full flex flex-col gap-8 px-[20px] ">
        <div className="flex flex-col gap-8 w-full md:flex-row md:divide-x-2">
          <div className="paragraph">
            <span className="text-lg font-extrabold">Team Ionis Paris</span>
            <span>
              Our team is composed of students from 3 different IONIS schools.
              We wanted each part to be done by specialized students in order to
              have the strongest project possible.
            </span>
          </div>

          <div className="paragraph !gap-4 md:w-1/2 md:pl-10">
            <span className="text-lg font-extrabold">
              Follow us social media:
            </span>
            <div className="flex gap-8">
              <SocialIcon url="https://www.instagram.com/igem.ionis/" />
              <SocialIcon url="https://www.linkedin.com/company/igem-ionis/mycompany/" />
              <SocialIcon url="https://www.gmail.com" />
            </div>
          </div>
        </div>
        <div className="paragraph">
          <span className="text-lg font-extrabold">
            Big thanks to our sponsors :
          </span>
          <div className="grid grid-cols-3 gap-4 md:grid-cols-5 md:gap-6">
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/beckman-coulter.svg"
                }
                alt="Beckman"
              />
            </div>

            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/bioconvs.png"
                }
                alt="Bioconvs"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/climatepartner2.png"
                }
                alt="Climate Partner"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/dna-script.png"
                }
                alt="DNA Script"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/dutscher.png"
                }
                alt="Dutscher"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/england-biolabs2.png"
                }
                alt="England Biolabs"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/epita.png"
                }
                alt="Epita"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/esme-sudria-logo.png"
                }
                alt="Esme Sudria Logo"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/idt.png"
                }
                alt="IDT"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/ionis2.png"
                }
                alt="Ionis"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/promega.png"
                }
                alt="Promega"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/rvb.png"
                }
                alt="RVB"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/snapgene2.png"
                }
                alt="SnapGene"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/supbio2.png"
                }
                alt="Supbio"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/synoxis-algae2.png"
                }
                alt="Synoxis Algae"
              />
            </div>
            <div className="image-container">
              <img
                src={
                  "https://static.igem.wiki/teams/4577/wiki/sponsors/sponsors/sponsors/twist.png"
                }
                alt="Twist"
              />
            </div>
          </div>
        </div>

        <div id="footer-text" className="paragraph !justify-center !items-center">
          <span>
            © 2023 - Content on this site is licensed under a
            <a className="link" href="https://creativecommons.org/licenses/by/4.0/">
              {" "}
              Creative Commons Attribution 4.0 International license
            </a>
          </span>
          <span>
            The repository used to create this website is available at
            <a className="link" href="https://gitlab.igem.org/2023/ionis-paris">
              {" "}
              https://gitlab.igem.org/2023/ionis-paris
            </a>
          </span>
        </div>
      </div>
    </section>
  );
}

export default Footer;
